import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import { connect } from "react-redux";
import {getProgramAuthors} from "../../../../store/actions";
import {changeProgramAuthors} from "../../../../store/send";
import {getOrganizationStaffAction} from "../../../../../Module/store/actions";
import { getOrganizations } from "../../../../../../ManageOOP/Resources/Person/store/actions";
import InfoBox from "../../../../../../ui/InfoDrawer/components/InfoBox";
import AddButton from "../../../../../../ui/AddButton";
import AddAuthorModal from "../../../../../Module/components/ModuleEdit/Tabs/Compilers/AddAuthorModal";
import EditOrganizationModal from "../../../../../Module/components/ModuleEdit/Tabs/Compilers/EditOrganizationModal";
import DeleteConfirmationModal from "../../../../../../ui/DeleteConfirmationModal";
import ClearIcon from "@material-ui/icons/Clear";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

const Authors = ({
                   getProgramAuthors,
                   changeProgramAuthors,
                   programAuthors,
                   getOrganizations,
                   organizationList,
                   getOrganizationStaffAction,
                   organizationStaff,
                   programId,
                   initialState = { organization: {}, staff: [] }
                 }) => {
  //const { organization, authors } = programAuthors;

  const [showAuthorDialog, setShowAuthorDialog] = useState(false);
  const [showOrganizationDialog, setShowOrganizationDialog] = useState(false);
  const [openDeleteAuthorModal, setOpenDeleteAuthorModal] = React.useState(
    false
  );
  const [activeAuthor, setActiveAuthor] = React.useState();
  const [state, setState] = useState(initialState);

  useEffect(() => {
    getProgramAuthors(programId);
    getOrganizations();
  }, [programId]);

  useEffect(() => {
    if (programAuthors) {
      const compilers = {
        organization: programAuthors.organization,
        staff: programAuthors.authors
      };
      setState(compilers);
    }
  }, [programAuthors, getOrganizationStaffAction]);

  useEffect(() => {
    if (programAuthors && programAuthors.organization) {
      getOrganizationStaffAction(programAuthors.organization.id);
    }
  }, [programAuthors, getOrganizationStaffAction]);

  const editOrganization = () => {
    const orgData = {
      type: "set-organization",
      program: programId,
      organization: state.organization.id
    };
    changeProgramAuthors(orgData);
    setShowOrganizationDialog(false);
  };

  const addAuthor = () => {
    const authors = {
      type: "add-author",
      program: programId,
      persons: state.staff.map(item => item.personId)
    };
    changeProgramAuthors(authors);
    setShowAuthorDialog(false);
  };

  const removeAuthor = personId => {
    const author = {
      type: "remove-author",
      program: programId,
      person: personId
    };
    changeProgramAuthors(author);
  };

  const change = (field, value) => {
    const newState = {
      ...state,
      [field]: value
    };
    setState(newState);
    field === "organization" && getOrganizationStaffAction(value.id);
  };

  return(
    <div>
      <DeleteConfirmationModal
        open={openDeleteAuthorModal}
        handleClose={() => setOpenDeleteAuthorModal(false)}
        modalText="Удалить составителя"
        additionalText={activeAuthor && activeAuthor.personName}
        onConfirm={() =>
          removeAuthor(activeAuthor.personId) || setOpenDeleteAuthorModal(false)
        }
      />
      <AddAuthorModal
        title="Добавление составителя"
        showDialog={showAuthorDialog}
        closeDialog={() => setShowAuthorDialog(false)}
        organizationList={organizationList}
        change={change}
        organizationStaff={organizationStaff}
        state={state}
        addAuthor={addAuthor}
      />
      <EditOrganizationModal
        title="Редактирование правообладателя"
        showDialog={showOrganizationDialog}
        closeDialog={() => setShowOrganizationDialog(false)}
        organizationList={organizationList}
        change={change}
        state={state}
        editOrganization={editOrganization}
      />
      <Box fontSize={14} mb={0}>
        Правообладатель
      </Box>
      <Grid item style={{ display: "flex", alignItems: "flex-start" }}>
        <InfoBox
          image={programAuthors && programAuthors.organization && programAuthors.organization.logo}
          desc={programAuthors && programAuthors.organization && programAuthors.organization.name}
        />
        <Tooltip title="Редактировать" placement="top">
          <IconButton onClick={() => setShowOrganizationDialog(true)}>
            <EditOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Grid>
      <Grid container alignItems="center">
        <Box fontSize={14} mb={0} mr={2}>
          Составители модуля
        </Box>
        <AddButton onClick={() => setShowAuthorDialog(true)} />
      </Grid>
      <Grid container alignItems="flex-start">
        {programAuthors && programAuthors.authors &&
        programAuthors.authors.map(item => (
          <Grid
            item
            key={item.personId}
            style={{ display: "flex", alignItems: "flex-start" }}
          >
            <InfoBox
              name={item.personName}
              image={item.personAvatar}
              desc={item.postName}
            />
            <Tooltip title="Удалить" placement="top">
              <IconButton
                onClick={() =>
                  setOpenDeleteAuthorModal(true) || setActiveAuthor(item)
                }
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

const mapStateToProps = state => ({
  programAuthors: state.programConstruct.programAuthors,
  organizationList: state.persons.organizations,
  organizationStaff: state.modules.organizationStaff
});

const mapDispatchToProps = dispatch => ({
  getProgramAuthors: (id) => dispatch(getProgramAuthors(id)),
  changeProgramAuthors: (data) => dispatch(changeProgramAuthors(data)),
  getOrganizationStaffAction: id => dispatch(getOrganizationStaffAction(id)),
  getOrganizations: () => dispatch(getOrganizations())
});

export default connect(mapStateToProps, mapDispatchToProps)(Authors)
